import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { getBoldText } from "../../../../utils/helpers/get-span-for-bold-text";

const ChooseYourPlanGraph = ({ graphData }) => {
    const { title, description, imageUrl } = graphData;

    if (!title) {
        return null;
    }

    return (
        <div styleName="styles.outer">
            <p styleName="styles.heading">{title}</p>
            <p styleName="styles.subHeading">{getBoldText(description)}</p>
            <div styleName="styles.graphImageWrapper">
                <img styleName="styles.graphImage" src={imageUrl} alt="Graph" />
            </div>
        </div>
    );
};

ChooseYourPlanGraph.propTypes = {
    graphData: PropTypes.object
};

export default ChooseYourPlanGraph;
